import { OtsBadge, type OtsBadgeTone } from '../components/OtsBadge';

const tones: Record<string, OtsBadgeTone> = {
  GENERATED: 'success',
  ACTIVE: 'success',
  COMPLETED: 'success',
  BLOCKED: 'danger',
  ERROR: 'danger',
  FAILED: 'danger',
  ERROR_BLOCKING: 'danger',
  READY_TO_BUILD: 'info',
  STALE_NEEDS_REGEN: 'warning',
  PENDING: 'warning',
  PROCESSING: 'info',
  WARNING: 'warning',
  WARN: 'warning',
  INACTIVE: 'neutral',
  SUPERSEDED: 'neutral',
  SKIPPED: 'neutral',
};
/** Unknown agency statuses stay neutral; never infer success from an unrecognised code. */
export const ComplianceStatusBadge = ({
  status,
  compact,
}: {
  status?: string;
  compact?: boolean;
}) => (
  <OtsBadge
    tone={tones[status?.toUpperCase() ?? ''] ?? 'neutral'}
    size={compact ? 'compact' : 'default'}
  >
    {status ? status.replace(/_/g, ' ') : 'Not reported'}
  </OtsBadge>
);
